import { render, staticRenderFns } from "./xtPuDetailReportList.vue?vue&type=template&id=65668f45"
import script from "./xtPuDetailReportList.vue?vue&type=script&lang=js"
export * from "./xtPuDetailReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports